import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, from, switchMap, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const excludedRoutes = [
    '/auth/login',
    '/auth/register',
    '/auth/refresh-token',
    '/auth/forgot-password',
    '/auth/email-verification'
  ];

  // Check if the request URL matches any excluded route
  const isExcluded = excludedRoutes.some(route => req.url.includes(route));

  // If excluded, pass duplicate request (or just req)
  if (isExcluded) {
    return next(req);
  }

  // Helper to add token
  const addToken = (request: any, token: string | null) => {
    if (token) {
      return request.clone({
        setHeaders: {
          Authorization: `${authService.getTokenType()} ${token}`
        }
      });
    }
    return request;
  };

  // Get current token
  const token = authService.getToken();
  const authReq = addToken(req, token);

  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {
      // Handle 401 Unauthorized
      if (error.status === 401) {
        return from(authService.getNewToken()).pipe(
          switchMap((data: any) => {
            // Save new tokens
            authService.saveToken(data);
            
            // Retry original request with new token
            const newToken = data.token;
            const newAuthReq = addToken(req, newToken);
            return next(newAuthReq);
          }),
          catchError((refreshError) => {
            // If refresh fails, logout and throw error
            authService.logout();
            return throwError(() => refreshError);
          })
        );
      }
      return throwError(() => error);
    })
  );
};
